/**
 * When Find does better than the map (Sam, 2026-10-13; the reasoning is in docs/roadmap.md's changelog for the day).
 *
 * Two phones on GPS put 30-60 ft of uncertainty on the map, so inside about 100 ft it cannot say which side of you
 * someone is; Bluetooth is reliably in range by 150 ft (the head start the UWB handshake needs); UWB locks at
 * roughly 30-100 ft in a crowd. The radar's outer ring is 60 m, so past that Find adds nothing.
 *
 * Offered from FIND_OFFER_M in, kept until FIND_KEEP_M, so a GPS jump of 30-60 ft does not flicker it on and off.
 */
export const FIND_OFFER_M = 45; // 150 ft
export const FIND_KEEP_M = 60; // 200 ft, the radar's edge

/** Whether Find is offered now, given the distance and whether it was offered a moment ago. */
export function findOffered(distanceM, wasOffered) {
  if (!Number.isFinite(distanceM)) return false;
  return wasOffered ? distanceM <= FIND_KEEP_M : distanceM <= FIND_OFFER_M;
}
